import "./emotion-is-prop-valid.cjs.js";
export { _default as default } from "./emotion-is-prop-valid.cjs.default.js";
